import React, {useState, useEffect} from 'react';
import {useHistory} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {RootContainer, LoginContainer, InputContainer, Input, SubmitButton, PageHeader, LoaderContainer} from './Login.styles'
import {authActions} from 'modules/auth';
import PropagateLoader from 'react-spinners/PropagateLoader'

export default () => {
	const dispatch = useDispatch()
	const history = useHistory();
	const authState = useSelector(state => state.authReducer);
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');

	const onVerifyPress = () => {
		dispatch(authActions.loginAsyncActions.request({email: email+'@videosummary.co', password}))
	}

	useEffect(() => {
		if(authState.loginSuccess) {
			history.push("/panel")
		}
	}, [authState])

	return (
		<RootContainer>
			<LoginContainer>
				<PageHeader>Admin Login</PageHeader>
				<InputContainer>
					<Input placeholder="Username" onChange={evt => setEmail(evt.target.value)}  /> &nbsp;@videosummary.co
				</InputContainer>
				<InputContainer>
					<Input placeholder="Password" onChange={evt => setPassword(evt.target.value)} fullWidth type="password" />
				</InputContainer>
				{
					authState.isLoading
					?
					<PropagateLoader size={15} color="#7289da" />
					:
					<LoaderContainer>
						<SubmitButton onClick={onVerifyPress} >Verify</SubmitButton>
					</LoaderContainer>
				}
			</LoginContainer>
		</RootContainer>
	)
}